import React from 'react';
import {  EmailToDataCreateNewContainer} from '../../Containers/EmailContainer';



export const EmailToDataCreate = (props) => {
	return (
		<EmailToDataCreateNewContainer />
	);
}
export default EmailToDataCreate;